/**
 * Validates Ethiopian phone number format
 * Accepts: 9XXXXX, 09XXXXX, +2519XXXXX, 2519XXXXX
 */
export function isValidEthiopianPhone(phone: string): boolean {
  const cleaned = phone.replace(/\s+/g, '');

  // Check if it matches any valid Ethiopian phone format
  const patterns = [
    /^9\d{8}$/,           // 9XXXXXXXX
    /^09\d{8}$/,          // 0996330808X
    /^\+2519\d{8}$/,      // +2519XXXXXXXX
    /^2519\d{8}$/,        // 2519XXXXXXXX
  ];

  return patterns.some(pattern => pattern.test(cleaned));
}

/**
 * Converts Ethiopian phone number to +2519XXXXX format
 */
export function normalizeEthiopianPhone(phone: string): string {
  const cleaned = phone.replace(/\s+/g, '');

  // Already in +2519XXXXX format
  if (cleaned.startsWith('+2519')) {
    return cleaned;
  }

  // 2519XXXXX format
  if (cleaned.startsWith('2519')) {
    return '+' + cleaned;
  }

  // 09XXXXX format
  if (cleaned.startsWith('09')) {
    return '+251' + cleaned.slice(1);
  }

  // 9XXXXX format
  if (cleaned.startsWith('9')) {
    return '+251' + cleaned;
  }

  return cleaned;
}

/**
 * Formats phone number for display (9XX XXX XXX)
 */
export function formatPhoneForDisplay(phone: string): string {
  const cleaned = phone.replace(/\s+/g, '');

  // Extract the 9 digits after country code
  let digits = '';
  if (cleaned.startsWith('+2519')) {
    digits = cleaned.slice(4);
  } else if (cleaned.startsWith('2519')) {
    digits = cleaned.slice(3);
  } else if (cleaned.startsWith('09')) {
    digits = cleaned.slice(1);
  } else if (cleaned.startsWith('9')) {
    digits = cleaned;
  }

  // Format as 9XX XXX XXX
  if (digits.length >= 9) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)}`;
  }

  return phone;
}
